import React from "react";

export const AuditLogsBodyTable = ({ date, time, message, by }) => {
  return (
    <React.Fragment>
      <tr className="auditLogsBodyTable">
        <td style={{ width: 70 }}>
          <div className="f10-400 c_black">{date}</div>
          <div className="f10-400 c_black">{time}</div>
        </td>
        <td>
          <div className="f10-400 c_black">{message}</div>
        </td>
        <td style={{ width: 90 }}>
          <div className="f10-400 c_black text-right">{by}</div>
        </td>
      </tr>
    </React.Fragment>
  );
};
